document.addEventListener('DOMContentLoaded', function() {
    const sliders = document.querySelectorAll('.slider-banner-block .swiffy-slider');
    
    sliders.forEach(function(slider) {
        initSliderNavigation(slider);
    });
    
    function initSliderNavigation(slider) {
        const container = slider.querySelector('.slider-container');
        const prevBtn = slider.querySelector('.slider-nav:not(.slider-nav-next)');
        const nextBtn = slider.querySelector('.slider-nav-next');
        if (!container || !prevBtn || !nextBtn) return;
        updateNavButtons();
        container.addEventListener('scroll', updateNavButtons);
        
        prevBtn.addEventListener('click', function() {
            setTimeout(updateNavButtons, 100);
        });
        
        nextBtn.addEventListener('click', function() {
            setTimeout(updateNavButtons, 100);
        });
        
        function updateNavButtons() {
            const scrollLeft = container.scrollLeft;
            const scrollWidth = container.scrollWidth;
            const clientWidth = container.clientWidth;
            
            if (scrollLeft <= 0) {
                prevBtn.setAttribute('disabled', 'true');
                prevBtn.classList.add('disabled');
            } else {
                prevBtn.removeAttribute('disabled');
                prevBtn.classList.remove('disabled');
            }
            
            if (scrollLeft + clientWidth >= scrollWidth - 1) {
                nextBtn.setAttribute('disabled', 'true');
                nextBtn.classList.add('disabled');
            } else {
                nextBtn.removeAttribute('disabled');
                nextBtn.classList.remove('disabled');
            }
        }
    }
});